<section class="pbw-panel">
  <!--
  Lo que pasó al registrar, y a dónde se va desde aquí.

  Este paso ya no pregunta nada: la confirmación del alta vive al final de la revisión, junto a las
  cifras que confirma. Aquí solo se rinde cuentas de lo que se creó.
  -->
  <h2 class="pbs-title">Los pagos ya están registrados</h2>
  <p class="pbs-lead">{{ state.register?.message }}</p>

  <div class="pbs-summary">
    <div class="pbs-stat is-ok">
      <div class="pbs-stat-v">{{ state.register?.totalProcessed || 0 }}</div>
      <div class="pbs-stat-l">Pagos creados</div>
    </div>
    <div class="pbs-stat">
      <div class="pbs-stat-v">{{ state.register?.totalAmount || 0 | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</div>
      <div class="pbs-stat-l">Dinero registrado</div>
    </div>
    <div class="pbs-stat is-warn" *ngIf="state.register?.totalDuplicates">
      <div class="pbs-stat-v">{{ state.register?.totalDuplicates }}</div>
      <div class="pbs-stat-l">Posibles duplicados, sin crear</div>
    </div>
    <div class="pbs-stat is-danger" *ngIf="state.register?.totalErrors">
      <div class="pbs-stat-v">{{ state.register?.totalErrors }}</div>
      <div class="pbs-stat-l">Filas que fallaron</div>
    </div>
  </div>

  <div class="pbs-notice is-ok">
    <i class="fa-solid fa-link" aria-hidden="true"></i>
    <div>
      <strong>Esta dirección recupera el lote</strong>
      Si cierras la pestaña, vuelve a <code>/cobranza/lote/{{ state.uploadBatch }}</code> y sigues donde te quedaste.
    </div>
  </div>

  <div class="pbs-table-wrap" *ngIf="state.register?.totalErrors || state.register?.totalDuplicates">
    <table class="pbs-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Cliente</th>
          <th class="num">Monto</th>
          <th>Qué pasó</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of state.register?.rows" [class.is-error]="r.status === 'ERROR'" [class.is-warn]="r.status === 'POSIBLE DUPLICADO'">
          <ng-container *ngIf="r.status !== 'SUCCESS'">
            <td>{{ r.rowNumber }}</td>
            <td>{{ r.clientName }}</td>
            <td class="num">{{ r.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
            <td>{{ r.message }}</td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pbs-actions">
    <button pButton type="button" label="Salir" class="p-button-text p-button-secondary pbs-left" (click)="onExit.emit()"></button>
    <button
      pButton
      type="button"
      [label]="state.mode === 'SOLO_ALTA' ? 'Terminar' : 'Elegir a dónde va cada pago'"
      [icon]="state.mode === 'SOLO_ALTA' ? 'fa-solid fa-check' : 'fa-solid fa-chevron-right'"
      iconPos="right"
      (click)="continuar()"
    ></button>
  </div>
</section>
